module.exports = {"noData":"Dáta nie sú k dispozícii"}